import { fetch } from 'api/typedFetch';

import { localStorage } from 'helpers/localStorage';

export const getData = async (id: string) => {
  const user = localStorage.get('USER');

  const params = new URLSearchParams({
    first_name: user?.firstName || '',
    last_name: user?.lastName || '',
    app_id: id,
    email: user?.email || '',
  });

  try {
    const response = await fetch('GET_DIPLOMA', { params });

    if (response?.ok) {
      return response.url;
    }
  } catch (error) {
    console.error('Fetching diploma failed:', error);
  }

  throw new Error('Failed to get diploma');
};
